import { FunctionComponent } from 'react';

/**
 * Packages & Components
 */
import {
  useRouteMapping,
  IconIllustration,
  ErrorFallback
} from '@astrumu/ui-library';

const PageNotFoundScreen: FunctionComponent = () => {
  const routeMapping = useRouteMapping('toolkit-mba');

  return (
    <ErrorFallback
      icon={<IconIllustration.Undraw404 />}
      navigation={{
        route: routeMapping.getPathByPageName('IndexPage'),
        text: 'go to the home page'
      }}
      title="Looks like the page you’re looking for does not exist."
      description="We apologize for the inconvenience.  
      We recommend to go back to the home page and start your search again. 
      If you still need help locating an important resource, please contact our support team."
    />
  );
};

export default PageNotFoundScreen;
